import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

import CurrentLanguage from '@/components/CurrentLanguage.vue';
import MediaList from '@/components/media/MediaList.vue';
import { Category, titleRules } from '@/models/category.model';
import { MediaPurpose } from '@/models/media.model';
import { useEvents, Event } from '@/services/events.composable';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { CategoriesActions, CategoriesState } from '@/stores/categories.store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, ref, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'CategoryForm',
  props: {
  data: {
    type: Object as PropType<Category>,
  },
},
  setup(__props) {

const store = useStore<ShiftCMSState & { cs: CategoriesState }>();
const events = useEvents();

const props = __props;

const valid = ref<boolean>(false);

const category = ref<Category>({
  id: NEW_ID,
  index: 0,
  title: '',
  tileTitle: '',
  color: '#979797',
  emoji: '🌱',
  media: [],
  isContent: true,
  parentCategory: null,
});

const action = computed<string>(() =>
  category.value.id === NEW_ID ? 'Add' : 'Save',
);

const saveCategory = async () => {
  let success: boolean = false;
  if (valid.value) {
    if (category.value.id === NEW_ID) {
      success = await store.dispatch(
        CategoriesActions.AddCategory,
        category.value,
      );
    } else {
      success = await store.dispatch(
        CategoriesActions.UpdateCategory,
        category.value,
      );
    }
  }
  if (success) {
    events.emit(Event.Saved, true);
    store.dispatch(Actions.ShowNotification, {
      message: 'Saved category',
      type: 'success',
    });
    store.commit(Mutations.HideDrawer);
    store.dispatch(CategoriesActions.GetCategories);
  } else {
    store.dispatch(Actions.ShowNotification, {
      message: 'Failed to save category',
      type: 'error',
    });
  }
};

const updateLanguage = async () => {
  if (category.value.id === NEW_ID) {
    Object.assign(category, { title: '' });
  } else {
    const cat = await store.dispatch(
      CategoriesActions.GetCategory,
      category.value.id,
    );

    if (cat) {
      Object.assign(category.value, { ...cat });
    }
  }
};

onMounted(() => {
  events.on(Event.LanguageChanged, updateLanguage);
  if (props.data) {
    Object.assign(category.value, props.data);
  }
});

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, updateLanguage);
});

const removeCategory = async () => {
  if (
    category.value &&
    category.value.id !== NEW_ID &&
    confirm('Are you absolutely sure you want to delete this "Category"?')
  ) {
    store.dispatch(CategoriesActions.DeleteCategory, category.value.id);

    store.commit(Mutations.HideDrawer);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_color_picker = _resolveComponent("v-color-picker")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(saveCategory, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, [
            _createTextVNode(_toDisplayString(_ctx.$t(action.value)) + " a category ", 1),
            _createVNode(CurrentLanguage)
          ]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: category.value.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((category.value.title) = $event)),
                    rules: _unref(titleRules),
                    label: "Title",
                    required: ""
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                class: "mx-auto",
                width: "5%",
                cols: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: category.value.emoji,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((category.value.emoji) = $event)),
                    label: "Emoji",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: category.value.tileTitle,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((category.value.tileTitle) = $event)),
                    rules: _unref(titleRules),
                    label: "Tile title",
                    hint: "Used on the home screen, when choosing the topic to focus on",
                    required: ""
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                style: {"position":"relative"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_dialog, { width: "auto" }, {
                    activator: _withCtx(({ props: activatorProps }) => [
                      _cache[7] || (_cache[7] = _createElementVNode("label", { style: {"position":"absolute","top":"0","left":"0","color":"#767676","font-size":"13px"} }, "Color", -1)),
                      _createElementVNode("div", _mergeProps(activatorProps, {
                        style: `margin-top: 4px; height: 60%; width: 100%; background-color: ${category.value.color}`
                      }), null, 16)
                    ]),
                    default: _withCtx(({}) => [
                      _createVNode(_component_v_color_picker, {
                        modelValue: category.value.color,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((category.value.color) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { align: "right" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    label: "Content",
                    modelValue: category.value.isContent,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((category.value.isContent) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (category.value.isContent)
                ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("A "),
                      _createElementVNode("i", null, "content category", -1),
                      _createTextVNode(" is a category that can be interacted with by the user. It is an option when choosing interests, for example. ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!category.value.isContent)
                ? (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("A "),
                      _createElementVNode("strong", null, "non-", -1),
                      _createElementVNode("i", null, "content category", -1),
                      _createTextVNode(" is a category that cannot be interacted with by the user. It is used to show certain co2 values that the user cannot change. ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(MediaList, {
            modelValue: category.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((category).value = $event)),
            required: [_unref(MediaPurpose).BackgroundImage]
          }, null, 8, ["modelValue", "required"]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { col: "2" }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "button",
                    color: "warning",
                    onClick: removeCategory,
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("Delete")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "reset",
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("Reset")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "submit",
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { col: "2" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})